<template>
    <div class="breadcrumb" v-if="!!show && name !== 'auto'">
        <el-breadcrumb class="container" separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>{{ name }}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'v-breadcrumb',
    data() {
        return {
            routeName: '',
            show: false,
        };
    },
    computed: {
        ...mapGetters(['breadcrumb']),
        name() {
            return this.breadcrumb || this.routeName;
        },
    },
    created() {
        this.checkRoute(this.$route);
    },
    watch: {
        $route(val) {
            this.checkRoute(val);
        },
    },
    methods: {
        checkRoute(route) {
            this.routeName = route.meta.name;
            this.show = route.meta.showBreadCrumb;
        },
    },
};
</script>

<style lang="less" scoped>
.breadcrumb {
    height: 60px;
    /*  background-color: #eee; */
    /deep/.el-breadcrumb {
        line-height: 60px;
    }
}
</style>
